module.exports = __webpack_public_path__ + "static/media/pg.7160f7d1.jpg";